<template>
	<div></div>
</template>
<script>
    import {mapGetters} from 'vuex';
    import {store} from '../../store/index';


    export default {
    	computed: {
            ...mapGetters([
                'getToken',
    			'getContractIdForSignature',
    		])
    	},
    	created() {
    		store.dispatch('setContractIdForSignature', this.$route.params.id);

            if (this.getToken) {
                this.$router.push('/signing-review/' + this.$route.params.id);
            } else {
                this.$router.push('/register?register=contract' + (this.$route.query.email ? '&email=' + this.$route.query.email : ''));
            }
    	}
    }
</script>
